import { Injectable } from '@angular/core';
import { LoginService } from '../../../features/login/login.service';
import { gigyaInfo } from '../../../types/gigyaInfo';
import { Observable, of, throwError } from 'rxjs';
import jwt_decode from 'jwt-decode';

@Injectable({
    providedIn: 'root'
})

export class TokenService {

    decodeJwtToken(token: string): any {
        if(token) {
            const decodedToken = jwt_decode(token);
            return decodedToken;
        }
        return null;
    }
    
}